import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Button, Menu, MenuItem } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import Loading from "../../components/loadingSpinner/Loading";
import "./PaymentDetails.css";

@inject("hgBillingStore")
@withRouter
@observer
class PaymentDetails extends Component {
    state = {
        actionAnchor: [],
        isLoading: false
    };

    componentDidMount() {
        this.setState({ isLoading: true });
        this.props.hgBillingStore.getPaymentMethod().then((response) => {
            this.setState({ isLoading: false });
        });
    }

    addCard = () => {
        this.props.hgBillingStore.addPaymentMethod().then((response) => {
            window.open(response.url, '_system');
        });
    };

    setDefaultPaymentMethod = (id) => {
        this.setState({ isLoading: true });
        this.props.hgBillingStore.setDefaultPaymentMethod(id).then((response) => {
            this.unsetActionAnchor();
            this.setState({ isLoading: false });
        });
    };

    deleteCard = (id) => {
        this.setState({ isLoading: true });
        this.props.hgBillingStore.deletePaymentMethod(id).then((response) => {
            this.props.hgBillingStore.reloadAccessSynch().then(() => {
                this.unsetActionAnchor();
                this.setState({ isLoading: false });
            });
        });
    };

    setActionAnchor = (element, cardId) => {
        var tempAnchor = [];
        tempAnchor[cardId] = element;
        this.setState({ ...this.state, actionAnchor: tempAnchor });
    };

    unsetActionAnchor = () => {
        this.setState({ ...this.state, actionAnchor: [] });
    };

    getCardBrandClass = (brand) => {
        switch (brand) {
            case 'visa':
                return 'visa';
            case 'mastercard':
                return 'mastercard';
            case 'amex':
                return 'amex';
            case 'discover':
                return 'discover';
            default:
                return 'default-icon';
        }
    };

    getCardBrandIcon = (brand) => {
        switch (brand) {
            case 'visa':
                return 'fa-brands fa-cc-visa';
            case 'mastercard':
                return 'fa-brands fa-cc-mastercard';
            case 'amex':
                return 'fa-brands fa-cc-amex';
            case 'discover':
                return 'fa-brands fa-cc-discover';
            default:
                return 'fa-solid fa-credit-card';
        }
    };

    renderPaymentCard = (data, defaultPayment) => {
        const isDefault = data.id === defaultPayment;
        const brandClass = this.getCardBrandClass(data?.card?.brand);
        const brandIcon = this.getCardBrandIcon(data?.card?.brand);
        const holderName = data?.billing_details?.name || 'Card Holder';

        return (
            <div 
                key={data.id} 
                className={`payment-card ${isDefault ? 'default' : ''}`}
            >
                <div className="payment-card-header">
                    <div className="payment-card-brand">
                        <i className={`${brandIcon} payment-card-brand-icon ${brandClass}`}></i>
                        <div className="payment-card-info-mobile">
                            <span className="payment-card-number">
                                •••• {data?.card?.last4}
                                {isDefault && <span className="default-badge-inline">Default</span>}
                            </span>
                            <div className="payment-card-details-inline">
                                {holderName} · Expires {data?.card?.exp_month}/{data?.card?.exp_year}
                            </div>
                        </div>
                    </div>
                    <Button 
                        className="payment-card-menu-btn"
                        onClick={e => this.setActionAnchor(e.currentTarget, data?.id)}
                        aria-label="Card actions menu"
                    >
                        <i className="fa-solid fa-ellipsis-vertical"></i>
                    </Button>
                    <Menu
                        open={this.state.actionAnchor[data?.id] != null}
                        onClose={() => this.unsetActionAnchor()}
                        anchorEl={this.state.actionAnchor[data?.id]}
                    >
                        {!isDefault && (
                            <MenuItem onClick={() => this.setDefaultPaymentMethod(data?.id)}>
                                <i className="fa-solid fa-check" style={{ marginRight: 10, width: 16 }}></i>
                                Set as Default
                            </MenuItem>
                        )}
                        <MenuItem 
                            onClick={() => this.deleteCard(data?.id)}
                            style={{ color: '#e53935' }}
                        >
                            <i className="fa-solid fa-trash" style={{ marginRight: 10, width: 16 }}></i>
                            Delete Card
                        </MenuItem>
                    </Menu>
                </div>
                <div className="payment-card-details">
                    <div className="payment-card-holder">{holderName}</div>
                    <div className="payment-card-expiry">
                        Expires {data?.card?.exp_month}/{data?.card?.exp_year}
                    </div>
                </div>
                <div className="payment-card-footer">
                    {isDefault && <span className="default-badge">Default</span>}
                </div>
            </div>
        );
    };

    renderEmptyState = () => {
        return (
            <div className="empty-state">
                <div className="empty-state-icon">
                    <i className="fa-solid fa-credit-card"></i>
                </div>
                <h3>No payment methods saved yet</h3>
                <p>Add a card to easily pay for your subscription and services</p>
                <Button 
                    className="btn-add-first"
                    onClick={this.addCard}
                >
                    <i className="fa-solid fa-plus"></i>
                    Add Your First Card
                </Button>
            </div>
        );
    };

    render() {
        const { paymentMethods, defaultPayment } = this.props.hgBillingStore;
        const hasCards = paymentMethods && paymentMethods.length > 0;

        return (
            <Fragment>
                <Loading showed={this.state.isLoading} />
                <div className="payment-methods-section">
                    <div className="payment-methods-header">
                        <Button 
                            className="btn-add-card"
                            onClick={this.addCard}
                        >
                            <i className="fa-solid fa-plus"></i>
                            Add Card
                        </Button>
                    </div>

                    {hasCards ? (
                        <div className="payment-cards-grid">
                            {paymentMethods.map(data => this.renderPaymentCard(data, defaultPayment))}
                        </div>
                    ) : (
                        this.renderEmptyState()
                    )}
                </div>
            </Fragment>
        );
    }
}

export default PaymentDetails;
